import { extendObservable } from 'mobx';
import FlowServices from '../services/FlowServices';
import QuoteStore from '../../quote/store/QuoteStore';

class FlowStore {
  constructor() {
    extendObservable(this, {
      flow: null,
      flowStarted: false,
      modality: null,
      optimized: false,
      bot: false,
      showAllModalities: false
    });
  }

  legacySetModalityFlow = modalityId => {
    const map = this.mapModalityIdToString();
    this.flow = new FlowServices(map[modalityId]);
    this.legacyFinishQuoteSteps();
  };

  legacyFinishQuoteSteps = () => {
    const flowService = this.flow;
    const routes = flowService.flow;
    const updatedRoutes = [];
    const currentStepIndex = routes.findIndex(r => r.path === '/cotacao/resultado');

    routes.forEach((r, index) => {
      const uRoute = r;
      if (index <= currentStepIndex) {
        uRoute.finished = true;
      }
      updatedRoutes.push(uRoute);
    });

    this.flow.flow = updatedRoutes;
  };

  mapModalityIdToString() {
    return {
      96: 'executante-construtor',
      97: 'executante-prestador-de-servicos',
      98: 'executante-fornecedor',
      99: 'licitacao',
      122: 'judicial',
    };
  }

  startFlow(modalityId, modalityType) {
    this.modality = modalityType;
    this.flowStarted = true;
    QuoteStore.ModalityId = modalityId;
  }
}

const flowStore = new FlowStore();
/* istanbul ignore next line */
if (process.env.NODE_ENV === 'development') window.flowStore = flowStore;

export default flowStore;
